import {ShopLineItem} from './payment-item.model';

export class CreateSharedOrder {
  constructor(
    public phone_number: string = null
  ) {
  }
}

export class SharedOrderResponse {
  constructor(
    public locationId: string = null,
    public merchantId: string = null,
    public sharedOrderId: string = null,
    public status: string = null
  ) {
  }
}

export class SharedOrderAddItems {
  constructor(
    public createOrderRequest: ShopLineItem,
    public given_name: string = null,
    public family_name: string = null,
    public order_request_id: string = null
  ) {
  }
}
